import type {
  AfriexTransactionChannel,
  AfriexTransactionType,
  ProcessorWithEmpty,
} from '@/types';
import {capitalizeWords} from '@/utils/dashboard';

const BusinessConfigSummary = ({
  type,
  channel,
  processor,
}: {
  type: AfriexTransactionType;
  channel?: AfriexTransactionChannel;
  processor?: ProcessorWithEmpty;
}) => {
  const txTypeName = capitalizeWords(type?.replace(/_/g, ' '));
  const channelName = capitalizeWords(channel?.replace(/_/g, ' ') ?? '');
  const processorName = capitalizeWords(processor?.replace(/_/g, ' ') ?? '');

  if (type || channel || processor) {
    return (
      <div className="mt-6 p-4 bg-blue-50 dark:bg-blue-900/20 rounded-lg border border-blue-200 dark:border-blue-700">
        <div className="text-sm text-blue-800 dark:text-blue-200 space-y-1">
          {type && (
            <p>
              <strong>Transaction Type:</strong> {txTypeName}
            </p>
          )}
          {channel && (
            <p>
              <strong>Payment Method:</strong> {channelName}
            </p>
          )}
          {processor && (
            <p>
              <strong>Processor:</strong> {processorName}
            </p>
          )}
        </div>
      </div>
    );
  }
  return null;
};

export default BusinessConfigSummary;
